import { max } from 'lodash/fp';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { Table } from 'rsuite';

const AutoHeightTable = ({ reduceHeight, ...props }) => {
  const [height, setHeight] = React.useState(window.innerHeight);
  function handleResize() {
    setHeight(window.innerHeight);
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  });

  const tableHeight = max([height - reduceHeight, 500]);

  return <Table height={tableHeight} {...props} />;
};

AutoHeightTable.propTypes = {
  reduceHeight: PropTypes.number
};

AutoHeightTable.defaultProps = {
  reduceHeight: 420
};

export default AutoHeightTable;
